// should be identical to containers/_card.html.erb
import * as React from 'react'
/** @type {React.FC<Props>} */
const Card = ({
  title,
  children,
  noMargin = false,
  striped = false,
  block = false,
  noPadding = false
}) => {
  return (
    <div
      className={[
        'card',
        noMargin ? 'card__no-margin' : '',
        striped ? 'card--striped' : '',
        block ? 'card--block' : '',
        noPadding ? 'card__no-padding' : ''
      ].join(' ')}
    >
      {title && <h3 className="card__title">{title}</h3>}
      {children}
    </div>
  )
}
export default Card

/**
 * @typedef {object} Props
 * @property {string} [title]
 * @property {boolean} [noMargin]
 * @property {boolean} [block] `display: block`
 * @property {boolean} [striped]
 * @property {boolean} [noPadding]
 * @property {React.ReactNode} [children]
 */
